import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconScript2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="script-2, paper, page, contract, file, document, skills"><path d="M7 20.25H4.75C3.64543 20.25 2.75 19.3546 2.75 18.25V16.25H14.25V18.75C14.25 19.5784 14.9216 20.25 15.75 20.25C16.5784 20.25 17.25 19.5784 17.25 18.75V5.5C17.25 4.5335 18.0335 3.75 19 3.75C19.9665 3.75 20.75 4.5335 20.75 5.5V9H17.5" stroke="currentColor" strokeWidth="1.5"/><path d="M19 3.75H7.75C6.64543 3.75 5.75 4.64543 5.75 5.75V16" stroke="currentColor" strokeWidth="1.5"/><path d="M15.75 20.25H6" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconScript2;
